import { Grid } from '@mui/material'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import './Product.scss'
import { ICommonProduct } from '@Models/common.model'
import { BaseCheckBox } from '@Components/Form/BaseCheckBox/BaseCheckBox'
import BaseButton from '@Components/Form/BaseButton/BaseButton'
import { CommonService } from '@Services/common.service'

interface IProduct {
    product: ICommonProduct
    checkbox?: boolean
    action?: boolean
    actionTitle?: string
    additionalInfo?: boolean
    getActions?: (action: string, product?: ICommonProduct) => void
    balance?: boolean
    checked?: boolean
    page?: string
    productType?: 'inspection' | 'default' | 'PART'
    totalAmount?: boolean
}

function Product(props: IProduct) {
    const {
        product,
        checkbox = true,
        action = false,
        actionTitle = 'Dispose',
        additionalInfo = false,
        getActions,
        balance = true,
        checked = false,
        page = '',
        productType = 'default',
        totalAmount = false,
    } = props

    const classGeneratorForAction = () => {
        let classes = ''
        if (action && additionalInfo) {
            classes = 'd-flex justify-content-between'
        }
        if (action && !additionalInfo) {
            classes = 'text-right'
        }
        if (page === 'MY_VAULT') {
            classes = 'd-flex justify-content-between'
        }
        return classes
    }

    return (
        <div className="product-container">
            <div className="detail-container">
                <div className="img-container">
                    {checkbox && (
                        <BaseCheckBox
                            className="checkbox"
                            checked={checked}
                            onClick={() =>
                                getActions && getActions('checkbox', product)
                            }
                        />
                    )}
                    <div className="img-box">
                        <img
                            src={
                                product?.imageUrl ||
                                require('../../assets/images/icons/camera-icon.svg')
                                    .default
                            }
                            alt=""
                        />
                    </div>
                </div>
                <div className="product-info">
                    <div className="title">
                        {product?.name || product?.component || ' - '}
                    </div>
                    <div className="id">#{product?.serialCode || ' - '}</div>
                    {productType === 'inspection' ? (
                        <div className="inspection">
                            <div className="label">Inspection Id </div>
                            <div className="value">
                                {product?.inspectionSchedule?.code || ' - '}
                            </div>
                        </div>
                    ) : null}

                    <div className="detail">
                        <Grid container spacing={3}>
                            <Grid item lg={6} md={12} sm={12} xs={12}>
                                {productType !== 'PART' ? (
                                    <div className="content">
                                        <span className="label">Make</span>
                                        <span className="value">
                                            {product?.make || ' - '}
                                        </span>
                                    </div>
                                ) : (
                                    <div className="content">
                                        <span className="label">Component</span>
                                        <span className="value">
                                            {product?.component || ' - '}
                                        </span>
                                    </div>
                                )}
                                <div className="content">
                                    <span className="label">Due Date</span>
                                    <span className="value">
                                        {product?.dueDate || ' - '}
                                    </span>
                                </div>
                                {productType === 'default' ||
                                productType === 'inspection' ? (
                                    <div className="content">
                                        <span className="label">Fee</span>
                                        <span className="value">
                                            {product?.fee || ' - '}
                                        </span>
                                    </div>
                                ) : null}
                                {totalAmount ? (
                                    <div className="content">
                                        <span className="label">
                                            Total Amount
                                        </span>
                                        <span className="value">
                                            {product?.itemSubscription
                                                ?.totalAmount || ' - '}
                                        </span>
                                    </div>
                                ) : null}
                            </Grid>
                            <Grid item lg={6} md={12} sm={12} xs={12}>
                                {productType !== 'PART' ? (
                                    <div className="content">
                                        <span className="label">Model</span>
                                        <span className="value">
                                            {product?.model || ' - '}
                                        </span>
                                    </div>
                                ) : null}
                                <div className="content">
                                    <span className="label">Paid Date</span>
                                    <span className="value">
                                        {product?.paidDate || ' - '}
                                    </span>
                                </div>
                                {balance && (
                                    <div className="content">
                                        <span className="label">Balance</span>
                                        <span className="value">
                                            {product?.balance || ' - '}
                                        </span>
                                    </div>
                                )}
                                {productType === 'inspection' ? (
                                    <div className="content">
                                        <span className="label">
                                            Issue Date
                                        </span>
                                        <span className="value">
                                            {product?.inspectionSchedule
                                                ?.scheduledAt
                                                ? CommonService.dateFormat(
                                                      product
                                                          ?.inspectionSchedule
                                                          ?.scheduledAt
                                                  )
                                                : ' - '}
                                        </span>
                                    </div>
                                ) : null}
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>
            {action || additionalInfo || page === 'MY_VAULT' ? (
                <div className={`${classGeneratorForAction()} product-action`}>
                    {additionalInfo && (
                        // <div
                        //     className="additional-info"
                        //     onClick={() =>
                        //         getActions && getActions('additional')
                        //     }
                        // >
                        //     <span className="icon">
                        //         <AddIcon />
                        //     </span>
                        //     Additional Info
                        // </div>
                        <BaseButton
                            className="outline-red font-weight-bold"
                            onClick={() =>
                                getActions && getActions('view-detail', product)
                            }
                        >
                            View Detail
                        </BaseButton>
                    )}
                    {action && (
                        <>
                            <BaseButton
                                className="outline-red font-weight-bold"
                                onClick={() =>
                                    getActions &&
                                    getActions(actionTitle, product)
                                }
                            >
                                {actionTitle}
                            </BaseButton>
                        </>
                    )}
                    {page === 'MY_VAULT' && product?.status && (
                        <>
                            {product?.status !== 'BOUGHT' ? (
                                <div className="d-flex align-items-center">
                                    <FiberManualRecordIcon
                                        className="main-text mr-2"
                                        style={{ fontSize: 8 }}
                                    />{' '}
                                    <span
                                        style={{ fontSize: '12px' }}
                                        className="text-capitalize"
                                    >
                                        {CommonService.textCapitalize(
                                            product?.status
                                        )}
                                    </span>
                                </div>
                            ) : (
                                <BaseButton
                                    className="outline-red font-weight-bold"
                                    onClick={() =>
                                        getActions &&
                                        getActions(actionTitle, product)
                                    }
                                >
                                    {actionTitle}
                                </BaseButton>
                            )}
                        </>
                    )}
                </div>
            ) : (
                ''
            )}
        </div>
    )
}

export default Product
